import React from 'react';
import '@/pages/Extras.scss';

interface ExtrasLayoutProps {
  children: React.ReactNode;
  title: string;
}

const ExtrasLayout: React.FC<ExtrasLayoutProps> = ({ children, title }) => {
  return (
    <main className="container">
      <section className="extra-page__content">
        <h1>{title}</h1>
        {children}
      </section>
    </main>
  );
};

export default ExtrasLayout;
